export default function Logo({ className = "h-8 w-auto" }) {
  return (
    <img
      src="/images/logo.png"
      alt="Eco Mobile Solutions"
      className={className}
      data-testid="logo-mark"
    />
  );
}
